var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mb-3 mt-6"},[_c('v-col',[_c('h2',[_vm._v(_vm._s(_vm.$t('correspondentieBeheer.emails.title')))])])],1),_c('v-btn',{attrs:{"color":"primary","href":_vm.get_link}},[_vm._v(" "+_vm._s(_vm.$t('correspondentieBeheer.emails.link'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }